// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cbdf8b47","977":"d26c2826"}[chunkId] + ".chunk.js";
};